// extracted by mini-css-extract-plugin
export default {"root":"UaD96USaho"};